<template>
    <transition
        enter-active-class="duration-300 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <icon v-show="props.loading" icon="hero/outline/refresh" class="animate-spin" :class="[sizeClass]"></icon>
    </transition>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { Ref } from 'vue';
import { ComponentSize } from '@src/Common/DataGrid/types';

interface Props {
    loading?: boolean;
    size?: ComponentSize;
}

const props = withDefaults(defineProps<Props>(), {
    loading: false,
    size: 'base',
});

const sizeClass: Ref<string> = computed((): string => {
    const sizes = {
        xs: 'w-1.5 h-1.5',
        sm: 'w-2 h-2',
        base: 'w-2.5 h-2.5',
        lg: 'w-3 h-3',
        xl: 'w-3.5 h-3.5',
    };

    return sizes[props.size] ?? sizes.base;
});
</script>
